import { ListHeader } from '@/components/List'

import { Filter } from './components/Filter'
import { Sorter } from './components/Sorter'
import { Title } from './components/Title'

export function Header() {
  return <ListHeader filter={<Filter />} sorter={<Sorter />} title={<Title />} />
}
